import OldSitePromotionContainer from "components/Site/Promotion/_SitePromotion.container";
import SitePromotionContainer from "components/Site/Promotion/SitePromotion.container";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";

const SitePromotionPage = () => {
  const { isOciProduct } = useIsOciProduct();
  if (isOciProduct) {
    return <OldSitePromotionContainer />;
  }
  return <SitePromotionContainer />;
};

export default SitePromotionPage;
